import { SESSION_PATHS } from "./navigation.js";

// Mascot pick gate — pure decision core (MA-324).
//
// The gate ladder in App.jsx renders <MascotPickScreen> (a full-screen
// kid-facing interstitial) whenever the active child has completed
// onboarding but never picked a pencil pal. It is a GLOBAL app-level
// check — it re-evaluates on every render against whichever child is
// currently active, regardless of which surface is on screen.
//
// KidSwitcher.switchTo (a PARENT surface, /parent/*) calls
// switchActiveChild, which reloads the switched-to kid's progress IN
// PLACE without navigating — the parent is meant to stay on the
// dashboard (see switchActiveChild's own comment in App.jsx). If the
// newly-active kid never picked a mascot, the very next render tripped
// this gate and hijacked the parent into the kid-facing pal-pick screen
// before the dashboard could paint — the identical flaw the sibling
// placement gate (MA-155) was removed for.
//
// This is the PURE core so the parent-surface exclusion is unit-tested
// without a renderer. The kid still gets the one-time pick: /play/* (and
// every other kid surface) is NOT excluded, only /parent/*.
//
// MA-513: the mid-session exclusion used to key off a `screen` string
// derived from navigation.js's pathToScreen(pathname) — but pathToScreen
// only maps the legacy "/session" path, so on every real session URL
// (/play/session|reading|mixed|foundation) it fell back to "home" and
// this exclusion could never fire. Checking the real pathname against
// SESSION_PATHS directly (the same set App.jsx already uses for its
// page-fit shell) fixes the exclusion and needs no `screen` input at all.
export function shouldShowMascotGate({
  onboardingComplete,
  mascot,
  pathname,
}) {
  const needsMascot = !!onboardingComplete && !mascot;
  if (!needsMascot) return false;
  if (typeof pathname === "string" && SESSION_PATHS.has(pathname)) return false;
  if (typeof pathname === "string" && pathname.startsWith("/onboarding")) return false;
  if (typeof pathname === "string" && pathname.startsWith("/parent")) return false;
  return true;
}
